module.exports = __webpack_public_path__ + "static/media/a2.9aeb8053.jpg";